var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Form-03__Icn/40px/Form-03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Form-03__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Form-03__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,13 C23.8659932,13 27,16.1340068 27,20 C27,23.8659932 23.8659932,27 20,27 C16.1340068,27 13,23.8659932 13,20 C13,16.1340068 16.1340068,13 20,13 Z M20,15 C17.2385763,15 15,17.2385763 15,20 C15,22.7614237 17.2385763,25 20,25 C22.7614237,25 25,22.7614237 25,20 C25,17.2385763 22.7614237,15 20,15 Z",
    id: ".._.._src_svg_Icn_40px_Form-03__Oval-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm03);
export default __webpack_public_path__ + "static/media/Form-03.ad4db305fd58408e8608d3b4b381fc1f.svg";
export { ForwardRef as ReactComponent };